import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

// Types
import { ContainerProps } from './types';

// Styled Components
import {
  Container,
  IconContainer,
  TextContainer,
  Text,
  Filename,
  OpenButton,
} from './styles';

// Icons
import { CheckIcon } from '../../../assets/icons/CheckIcon';

/**
 * Aviso de que un fichero ya está guardado, con la opción de abrirlo.
 *
 * Solo aparece dentro de la app: en el navegador la descarga la anuncia el
 * propio navegador, y este toast sobraría.
 *
 * Sin claves i18n propias a propósito — se componen las que ya existen
 * (`toasts:success.saved` y `buttons:view`), según la regla del proyecto de no
 * crear claves sin confirmarlas con el equipo.
 */
export const FileSavedToast = ({
  filename,
  onOpen,
  ...props
}: ContainerProps): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Container {...props}>
      <IconContainer>
        <CheckIcon width={24} height={24} fill={theme.colors.green as string} />
      </IconContainer>
      <TextContainer>
        <Text size="M" variant="medium">
          {t('toasts:success.saved')}
        </Text>
        <Filename size="S" variant="regular" title={filename}>
          {filename}
        </Filename>
      </TextContainer>
      {onOpen && (
        <OpenButton type="button" onClick={onOpen}>
          {t('buttons:view')}
        </OpenButton>
      )}
    </Container>
  );
};

export default FileSavedToast;
